export const DESIGN_COMPONENTS = {
  TRUNCATED_TYPOGRAPHY_ZOOMED_NAME: 'truncated-typography-zoomed-name'
} as const;
